import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message } from '../../../chatbot-core/message/message.model';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';
import { InputService } from '../../input/input.service';
import { MathJaxConfigService } from '../../../shared/latex/mathjax-config.service';
import { EquationService } from '../../../shared/equation-editor/equation.service';

@Component({
    selector: 'sabis-chatbot-user-message',
    imports: [CommonModule, SafeHtmlPipe], // No MarkdownPipe
    templateUrl: './user-message.component.html',
    styleUrl: './user-message.component.scss'
})
export class SabisChatbotUserMessageComponent implements OnInit, OnChanges {
  @Input() public message!: Message;
  @Output('resend') onResendMessage: EventEmitter<Message> = new EventEmitter();
  @Output('edit') onEditMessage: EventEmitter<Message> = new EventEmitter();
  @ViewChild('messageContent', { read: ElementRef }) messageContentRef?: ElementRef<HTMLElement>;

  public displayedContent = '';
  public isBlinking = false;
  public isEditingMessage = false;

  private _currentPromise: Promise<void> | null = null;

  constructor(private _inputService: InputService, private _mathjaxConfService: MathJaxConfigService, private _equationService: EquationService) { }

  ngOnInit(): void {
    this.displayedContent = this.message.content;
    // restore editing state if this message was being edited before minimize
    const editingMessageId = this._inputService.getEditingMessageId();
    if (editingMessageId && editingMessageId === this.message.id) {
      this.isEditingMessage = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message']) {
      const currentMessage: Message | undefined = changes['message'].currentValue;
      this.displayedContent = currentMessage?.content ?? '';

      // draw equations for the updated content
        setTimeout(() => {
          this._equationService.restoreEquationMathML(this.messageContentRef!.nativeElement);
          if (this.messageContentRef?.nativeElement) {
            if (this._currentPromise) {
              this._currentPromise.then(() => this._mathjaxConfService.typeset(this.messageContentRef!.nativeElement));
            } else {
              this._currentPromise = this._mathjaxConfService.typeset(this.messageContentRef!.nativeElement);
            }
          }
        }, 0);
    }
  }

  ngAfterViewInit(): void {
    if (this.displayedContent) {
      setTimeout(() => {
        this._mathjaxConfService.typesetClear(this.messageContentRef!.nativeElement).then(x => {
          this._mathjaxConfService.typeset(this.messageContentRef!.nativeElement);
        });
      }, 0);
    }
  }

  public retryMessage(message: Message): void {
    this.isBlinking = true;
    this.onResendMessage.emit(message);
    setTimeout(() => {
      this.isBlinking = false;
    }, 1000);
  }

  public editMessage(message: Message): void {
    this.onEditMessage.emit(message);
    this.isEditingMessage = true;
  }

  public cancelEdit(): void {
    this.isEditingMessage = false;
  }
}
